<template>
    <div class="card card-input text-center" :class="classObject" @click="toggleSelect">
        <div class="card__body" v-bind:class="{ 'mobile-open': this.mobileOpen }">
            <figure @click="mobileShowSubDrivers"><img :src="categorySvg(category)"></figure>
            <svg @click="mobileShowSubDrivers" v-if="this.$store.getters.isMobile" class="icon icon-Add mobile-close"><use xlink:href="#icon-Add"></use></svg>
            <div class="header-group" @click="mobileShowSubDrivers">
                <div class="vert-group">
                    <h3 class="text-large-heading" v-html="breakTitle"></h3>
                    <span class="mobile-heading-helper" v-if="this.$store.getters.isMobile">Learn More</span>
                    <ul @click="mobileShowSubDrivers" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
                        <li @click="mobileShowSubDrivers" v-for="item in list">{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <div class="mobile-add__toggle" v-if="this.$store.getters.isMobile" @click="mobileToggleSelect">
                <span class="circle-button" :class="getColor(category)"><svg class="icon icon-Add"><use xlink:href="#icon-Add"></use></svg></span>
            </div>
        </div>
        <span v-if="!this.$store.getters.isMobile" class="circle-button" :class="getColor(category)"><svg class="icon icon-Add"><use xlink:href="#icon-Add"></use></svg></span>
    </div>
</template>

<script>
    import router from '../router.js';
    import Icon from './Icon';
    import EventBus from '../eventbus.js';

    export default {
        props : [
            'cardTitle',
            'list',
            'category',
            'driver'
        ],
        data : function() {
            return {
                isSelected: false,
                mobileOpen: false,
                mobileSmall: false
            }
        },
        created() {
            EventBus.$emit('stepOne.addCard', this);

            this.isSelected = this.driver.selected;

            EventBus.$on('mobileSmall', (mobileSmall) => {
                this.mobileSmall = mobileSmall;
            });
        },
        computed: {
            classObject: function () {
                return {
                    'is-selected': this.isSelected
                }
            },
            breakTitle: function() {
                if ( this.mobileSmall || !this.$store.getters.isMobile ) {
                    let title = this.cardTitle.split(' ')
                    return title[0] + '  <br>' + title[title.length - 1];
                }

                return this.cardTitle;
            }
        },
        mounted() {
            $('.col-auto').css('min-width', $('.col-auto').width() + 32);

            this.resizeElements();

            EventBus.$on('resize', (width) => {
                this.resizeElements();
            });
        },
        methods : {
            resizeElements() {
                const devInnerWidth = window.innerWidth;
                
                $('.col-auto').css(
                    {
                        'min-width': 'initial',
                        'width': 'initial',
                        'min-width': 'initial'
                    }
                );

                if ( devInnerWidth > 768 && devInnerWidth < 992 ) {
                    $('.col-auto').css(
                        {
                            'min-width': '300px',
                            'width': '300px',
                            'min-width': '300px'
                        }
                    );
                } else {
                    if ( this.$store.getters.isMobile ) {
                        $('.col-auto').css('min-width', $('.col-auto').width() + 32);
                    } else {
                        $('.col-auto').css('min-width', 'initial');
                    }
                }
            },
            getColor( category ) {
                let color = window.getCategoryColor( category );
                return 'is-' + color;
            },
            categorySvg( category ) {
                return '/'+category + '-icon.svg';
            },
            toggleSelect() {
                if ( !this.$store.getters.isMobile ) {
                    this.isSelected = !this.isSelected;
                    if ( this.isSelected ) {
                        this.addDriver();
                    } else {
                        this.removeDriver();
                    }

                    EventBus.$emit('updateDrivers', true);
                }
            },
            mobileToggleSelect() {
                if ( this.$store.getters.isMobile ) {
                    this.isSelected = !this.isSelected;
                    if ( this.isSelected ) {
                        this.addDriver();
                    } else {
                        this.removeDriver();
                    }

                    EventBus.$emit('updateDrivers', true);
                }
            },
            addDriver() {
                this.$store.dispatch('addPriority');
                this.driver.selected = true;
                this.driver.selected_order = this.$store.getters.priority;
            },
            removeDriver() {
                this.$store.dispatch('reducePriority');
                this.driver.selected = false;
                this.driver.selected_order = 0;
                // this.$store.dispatch('removeDriver', this.driver);
            },
            mobileShowSubDrivers() {
                if ( this.$store.getters.isMobile ) {
                    if ( this.$store.getters.isMobile ) {
                        this.mobileOpen = !this.mobileOpen;
                    }

                    if ( this.mobileOpen || window.innerWidth < this.$store.getters.mobileWidth ) {
                        $('h3.text-large-heading').each(function() {
                            let thisHeading = this;
                            $(thisHeading).text( $(thisHeading).text().replace('<br>', ' ')  );
                        });
                    } else {
                        $('h3.text-large-heading').each(function() {
                            let thisHeading = this;
                            $(thisHeading).html( $(thisHeading).text().replace(' ', '<br>')  );
                        });
                    }
                }
            }
        },
        components : {
            Icon
        }
    }
</script>


<style lang="css" scoped>
    figure {
        position: relative;
        margin: 0;
        font-size: 9em;
        line-height: 1;
        height: 1.125em;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CardInput.vue